import classes from './negativnaProgresija.module.css'
import classesK from '../kalkulatori.module.css'
import { useState } from 'react'
import InfoBar from '../redesign/components/InfoBar'
import OddsCalculator from '../redesign/components/OddsCalculator'
import ResultsSection from '../redesign/components/ResultsSection'
import runCalculator from '../api/runCalculator'
import add from '../images/add.svg'

const NegativnaProgresija = () => {
  const [showInputArea, setShowInputArea] = useState(true)
  const [data, setData] = useState({
    values: {
      serie1: ['', ''],
    },
    results: {
      serie1Results: ['-', '-', '-', '-'],
    },
  })

  const [error, setError] = useState(false)
  const [apiError, setApiError] = useState('')
  const [loading, setLoading] = useState(false)
  const [series, setSeries] = useState([{ id: 1 }])

  const clearFields = () => {
    setData({
      values: {
        serie1: ['', ''],
      },
      results: {
        serie1Results: ['-', '-', '-', '-'],
      },
    })

    setApiError('')
    setShowInputArea(true)
    setSeries([{ id: 1 }])
  }

  const buildBody = () => {
    const stakes = []
    const oddsList = []

    series.forEach((serie) => {
      const [stake, odds] = (data.values[`serie${serie.id}`] || ['', '']).map(
        parseFloat
      )

      stakes.push(Number.isNaN(stake) ? 0 : stake)
      oddsList.push(Number.isNaN(odds) ? 0 : odds)
    })

    return { stakes, oddsList }
  }

  const calculateAll = async () => {
    setLoading(true)
    setApiError('')

    try {
      const result = await runCalculator(
        'progressions',
        'negative-progression',
        buildBody()
      )

      const updatedResults = { ...data.results }

      series.forEach((serie, index) => {
        const row = result.rows[index]

        if (
          row &&
          row.potentialWin !== null &&
          row.loss !== null &&
          row.cumulativeStake !== null
        ) {
          updatedResults[`serie${serie.id}Results`] = [
            row.potentialWin.toFixed(2),
            row.loss.toFixed(2),
            row.cumulativeStake.toFixed(2),
            row.nextStakeHint,
          ]
        } else {
          updatedResults[`serie${serie.id}Results`] = ['-', '-', '-', '-']
        }
      })

      setData((prevData) => ({
        ...prevData,
        results: updatedResults,
      }))
    } catch (err) {
      setApiError('Greška pri obračunu, pokušajte ponovo.')
    } finally {
      setLoading(false)
    }
  }

  const addSeries = () => {
    setSeries((prevSeries) => {
      const newSeries = [...prevSeries, { id: prevSeries.length + 1 }]
      setData((prevData) => ({
        ...prevData,
        values: {
          ...prevData.values,
          [`serie${newSeries.length}`]: ['', ''], // Add new series to data.values
        },
        results: {
          ...prevData.results,
          [`serie${newSeries.length}Results`]: ['-', '-', '-', '-'], // Add new series results to data.results
        },
      }))
      return newSeries
    })
  }

  return (
    <div className={classesK.container}>
      <InfoBar
        calculatorType={`Negativna progresija`}
        onRefresh={clearFields}
      />
      <div className={classesK.contentContainer}>
        <div className={classesK.submitWrapper}>
          <span>Unesi obračunske podatke</span>
          <button onClick={calculateAll} disabled={loading}>
            {loading ? 'Obračun u toku...' : 'Prikaži rezultate'}
          </button>
        </div>
        {apiError && (
          <div style={{ color: 'red', textAlign: 'center', marginTop: '8px' }}>
            {apiError}
          </div>
        )}
        {showInputArea && (
          <>
            <div className={classes.sectionContainer}>
              <div className={classesK.sectionTitle}>Igra</div>
              {series.map((serie) => (
                <div key={serie.id} className={classes.seriesContainer}>
                  <div className={classes.seriesTitle}>
                    Serija br. {serie.id}
                  </div>
                  <div className={classes.seriesValues}>
                    <OddsCalculator
                      data={data.values}
                      setData={setData}
                      field={`serie${serie.id}`}
                      labelPrefix={['Upiši ulog', 'Upiši kvotu']}
                      step={['1', '0.1']}
                      min={['1', '0.1']}
                      type={['number', 'number']}
                      setError={setError}
                      rows={2}
                    />
                    <ResultsSection
                      names={[
                        'Eventualni dobitak',
                        'Gubitak u seriji',
                        'Ukupan dosadašnji ulog',
                        'Isplativost odnosa sledećeg uloga i kvote',
                      ]}
                      results={data.results[`serie${serie.id}Results`] || []}
                      rows={2}
                      allowNegative={true}
                    />
                  </div>
                </div>
              ))}
              {series.length < 25 && (
                <div className={classesK.addMore}>
                  <button onClick={addSeries} className={classesK.addButton}>
                    <img src={add} height={18} width={18} alt='image' />
                    Dodaj još jednu seriju
                  </button>
                </div>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  )
}

export default NegativnaProgresija
